module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-5e206751b986d4e196a6e0c8f7964844.svg";